import { firebaseAnalyticsAdapter } from '@/adapters/analytics';
import { createUserAwareAnalyticsAdapter } from '@/adapters/analytics/createUserAwareAnalyticsAdapter';
import { getCurrentAccountId } from '@/adapters/analytics/currentAccountId';
import { getCurrentUserId } from '@/adapters/analytics/currentUserId';
import { sentryLogger } from '@/adapters/logger/sentryLogger';
import { storage } from '@/adapters/storage/secureStorage';
import {
  createAiTranscriptionConsentStore,
  type AiTranscriptionConsentAdapters,
} from '@/stores/createAiTranscriptionConsentStore';

const productionAdapters: AiTranscriptionConsentAdapters = {
  secureStore: storage,
  logger: sentryLogger,
  analytics: createUserAwareAnalyticsAdapter(
    firebaseAnalyticsAdapter,
    () => getCurrentUserId(),
    () => getCurrentAccountId(),
  ),
};

const useAiTranscriptionConsentStore = createAiTranscriptionConsentStore(productionAdapters);

export { useAiTranscriptionConsentStore };
